import { useEffect, useState } from "react";
import api from "@/lib/api";
import DashboardLayout from "@/components/DashboardLayout";
import { Modal } from "./Projects";
import { Plus, Trash2, Star } from "lucide-react";

const blank = { client_name: "", location: "", rating: 5, content: "", project_type: "", featured: true };

export default function AdminTestimonials() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/testimonials").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    await api.post("/testimonials", { ...editing, rating: Number(editing.rating) });
    setEditing(null);
    load();
  };

  const remove = async (id) => {
    if (!window.confirm("Delete?")) return;
    await api.delete(`/testimonials/${id}`);
    load();
  };

  return (
    <DashboardLayout
      role="admin" title="Testimonials"
      subtitle="Reviews from happy clients shown on your homepage."
      actions={<button className="btn-primary" onClick={() => setEditing({...blank})}><Plus size={16}/> New</button>}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((t) => (
          <div key={t.id} className="card p-6">
            <div className="flex gap-1 mb-3">
              {Array.from({length: t.rating}).map((_, i) => <Star key={i} size={14} fill="#D4A373" stroke="none"/>)}
            </div>
            <p className="text-sm leading-relaxed mb-4">&ldquo;{t.content}&rdquo;</p>
            <div className="text-sm font-semibold">{t.client_name}</div>
            <div className="text-xs mb-4" style={{color:'var(--text-muted)'}}>{t.location} · {t.project_type}</div>
            <button className="btn-ghost !py-1.5 !px-3 !text-xs" onClick={() => remove(t.id)} style={{color:'#fca5a5'}}><Trash2 size={12}/></button>
          </div>
        ))}
      </div>

      {editing && (
        <Modal onClose={() => setEditing(null)} title="New Testimonial">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field label="Client name"><input className="input" value={editing.client_name} onChange={(e)=>setEditing({...editing, client_name: e.target.value})}/></Field>
            <Field label="Location"><input className="input" value={editing.location} onChange={(e)=>setEditing({...editing, location: e.target.value})}/></Field>
            <Field label="Project type"><input className="input" value={editing.project_type} onChange={(e)=>setEditing({...editing, project_type: e.target.value})}/></Field>
            <Field label="Rating"><input type="number" min="1" max="5" className="input" value={editing.rating} onChange={(e)=>setEditing({...editing, rating: e.target.value})}/></Field>
            <Field label="Content" full><textarea className="input" rows={4} value={editing.content} onChange={(e)=>setEditing({...editing, content: e.target.value})}/></Field>
            <label className="flex items-center gap-2 text-sm md:col-span-2">
              <input type="checkbox" checked={!!editing.featured} onChange={(e)=>setEditing({...editing, featured: e.target.checked})}/>
              Show on homepage
            </label>
          </div>
          <div className="flex gap-3 justify-end mt-6">
            <button className="btn-ghost" onClick={() => setEditing(null)}>Cancel</button>
            <button className="btn-primary" onClick={save}>Save</button>
          </div>
        </Modal>
      )}
    </DashboardLayout>
  );
}

function Field({ label, full, children }) {
  return (
    <label className={`block ${full ? 'md:col-span-2' : ''}`}>
      <div className="text-xs uppercase tracking-wider mb-2 font-semibold" style={{color:'var(--text-muted)'}}>{label}</div>
      {children}
    </label>
  );
}
